module ProcessEditor {
    "use strict";
    export class PromotedResultDirectiveController {
        public node: INodeWithPromotableResult;
        public resultPromoted: boolean;
        static $inject = ["PromotedResultVariablesService"];
        constructor(public promotedResultVariablesService: PromotedResultVariablesService) {
            if (this.node.promoteResultAs) {
                this.resultPromoted = true;
            }
        }
        public toggleCheckBox() {
            if (!this.resultPromoted) {
                this.node.promoteResultAs = null;
                this.promotedResultVariablesService.setNodePromotedVariable(this.node.nodeId, undefined);
            }
        }

        public onBlur() {
            // TODO: should we skip persist if the model has error -> value is undefined
            // persist the changes to the service so the var can be used elsewhere in the process
            this.promotedResultVariablesService.setNodePromotedVariable(this.node.nodeId, this.node.promoteResultAs);
        }
    }

    app.controller("PromotedResultDirectiveController", PromotedResultDirectiveController);

    export function promotedResultDirective(): ng.IDirective {
        return {
            restrict: "EA",
            bindToController: {
                node: "="
            },
            templateUrl: "promotedResultTemplate.htm",
            controller: PromotedResultDirectiveController,
            controllerAs: "prCtrl"
        }
    }
    app.directive("frendsPromotedResult", promotedResultDirective);
}